import d3 from 'd3';
import { Signal } from 'signals';

// import Facet from './facets/Facet.es6';
import ArrayFacet from './facets/ArrayFacet.es6';
import ContinuousFacet from './facets/ContinuousFacet.es6';
import Continuous2DFacet from './facets/Continuous2DFacet.es6';
import { serialize } from './TextUtils.es6';

export default class Archive {

  constructor(archiveConf, globalConf) {
    this._apiUrl = globalConf.apiUrl;
    this._queryPath = globalConf.queryPath;
    this.title = archiveConf.title;
    this.sectionIntro = archiveConf.sectionIntro;
    this._facets = this._createFacets(archiveConf.facets);
    // this._cache = {};

    this.dataChanged = new Signal();
    this.queryStarted = new Signal();
  }

  getFacet(id) { return this._facets[id]; }
  get facets() { return Object.keys(this._facets).map(key => this._facets[key]); }

  loadFacetsMetadata() {
    console.info('loading facets metadata');
    return Promise.all(this.facets.map(facet => facet.loadMetadata())).then(
      values => {
        console.info('facets metadata loaded');
        return this;
      },
      error => {
        console.warn('facets metadata error');
        throw error;
      }
    );
  }

  query(queryObj) {
    console.info('Query started');
    this.queryStarted.dispatch();
    return this._loadJSON(this._apiUrl + this._queryPath, queryObj)
      .then(
        data => {
          console.info('Query result loaded');
          // this._cache[JSON.stringify(queryObj)] = data;
          return this._joinMetadata(data);
        },
        error => {
          console.warn('Query error');
          throw error;
        }
      ).then(
        () => this.dataChanged.dispatch(),
        error => {
          console.warn('Join operation failed');
          throw error;
        }
      );
  }

  // HANDLERS

  _onFacetSelectionChanged() {
    // get extents from all facets and do query;
    const queryObj = this.facets.reduce((memo, facet) => Object.assign(memo, facet.query), {});
    console.log(queryObj);
    this.query(queryObj);
  }

  _onDataChanged(facet) {
    console.log(`data changed in facet ${facet.name}`);
  }

  // HELPERS

  _createFacets(facetsConf) {
    return facetsConf.reduce(
      (memo, facetConf) => {
        const Facet = Archive.FACET_MAP[facetConf.type];
        const facet = new Facet(this._apiUrl, facetConf);
        facet.selectionChanged.add(() => this._onFacetSelectionChanged());
        memo[facetConf.id] = facet;
        return memo;
      },
      {}
    );
  }

  _loadJSON(path, query) {
    return new Promise((resolve, reject) => {
      const req = d3.json(`${path}?${serialize(query)}`);
      req.send('get', query, (error, data) => {
        if (error) reject(Error(error));
        else resolve(data);
      });
    });
  }

  _joinMetadata(data) {
    return new Promise((resolve, reject) => {
      this.facets.forEach(facet => facet.join(data));
      this.total = data.total;
      this.selected = data.selected;
      resolve();
    });
  }

}

Archive.FACET_MAP = {
  categorical: ArrayFacet,
  continuous: ContinuousFacet,
  continuous2D: Continuous2DFacet,
};



/** WEBPACK FOOTER **
 ** D:/2016/2016 - ISI/grantorino/frontend/../../../../Marco/Dropbox (ISI Foundation)/2016 - ISI/grantorino/frontend/src/js/models/Archive.es6
 **/